import { DetailsPolicyActionTypes, DetailsPolicyState } from './types';
import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as policyActions from './actions';
import cloneDeep from "lodash.clonedeep";

export type PolicyAction = ActionType<typeof policyActions>;

const initialState: DetailsPolicyState = {
  policy: {
    insurerPartyName: '',
    contractNumber: 0,
    policySubTypeTC: '',
    contractClassification: '',
    policyTypeTC: '',
    contractName: '',
    policyCode: '',
    inspectorName: '',
    conditions: '',
    dateOfCommencement: '',
    dateOfExpiration: '',
    indirectLossesPercentage: 0,
    buildingIndexSubscription: 0,
    buildingIndexClaim: 0,
    consumptionIndexSubscription: 0,
    consumptionIndexClaim: 0,
    legalExcessAmount: 0,
    loweredExcessAmountThreshold: 0,
    damageCaseCode: '',
    docNotificationDamageLossDate: '',
    insuredAmountBuilding: 0,
    excessAmountBuilding: 0,
    raisedExcessAmountBuilding: 0,
    indirectLossesBuilding: false,
    guaranteeTCBuilding: '',
    insuredAmountContent: 0,
    excessAmountContent: 0,
    raisedExcessAmountContent: 0,
    indirectLossesContent: false,
    guaranteeTCContent: '',
    policyHolderLanguageTC: '',
    DVVStarsUsed: false,
    EnglishFranchise: false,
  },
  insuredRisk: {
    street: '',
    buildingNumber: 0,
    boxNumber: 0,
    zipCode: 0,
    city: '',
    country: '',
    locationDescription: '',
    constructionYear: 0,
    typeOfProperty: '',
    typeOfConstruction: '',
    hasElevator: false,
    isListed: false,
    hasRoomsWithCeilingHigherThan4m: false,
    hasInstalledKitchen: false,
    hasCentralHeating: false,
    hasRoofingFromCaneOrStraw: false,
    hasMoreThanOneSideInNaturalStone: false,
    hasHeatedSwimmingPool: false,
    hasASideOfBuildingBiggerThan40SquareMeters: false,
    hasMoreThan5Floors: false,
    hasFloorInNaturalStoneOrSolidParquet: false,
    numberOfInsuredSurfaces: 0,
    numberOfRooms: 0,
    numberOfLivingRooms: 0,
    numberOfBathrooms: 0,
    numberOfGarages: 0,
    numberOfOffices: 0,
    numberOfBedrooms: 0,
    numberOfKitchens: 0,
    numberOfOtherPlaces: 0,
    numberOfConservatories: 0,
  },
  clauses: [],
  guarantees: [],
};

const reducer: Reducer<DetailsPolicyState, PolicyAction> = (state = initialState, action): DetailsPolicyState => {
  switch (action.type) {
    case DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL_SUCCESS: {
      return {
        ...state,
        policy: cloneDeep(action.payload.policyViewModel.policy),
        insuredRisk: cloneDeep(action.payload.policyViewModel.insuredRisk),
        clauses: cloneDeep(action.payload.policyViewModel.clauses),
        guarantees: cloneDeep(action.payload.policyViewModel.guarantees)
      };
    }
    case DetailsPolicyActionTypes.RESET_STATE: {
      return initialState;
    }
    case DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL_FAIL:
    default: {
      return state;
    }
  }
};

export { reducer as detailsPolicyReducer, initialState as detailsPolicyInitialState };
